import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, trackCallConversion } from '../utils/phone';
interface CtaButtonsProps {
  align?: 'center' | 'start';
  className?: string;
}

/** Primary "Get a Quote" + secondary "Call or Text" pair used across the site. */
export function CtaButtons({
  align = 'center',
  className = ''
}: CtaButtonsProps) {
  const alignment = align === 'center' ? 'sm:justify-center' : 'sm:justify-start';
  return <div className={`flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 ${alignment} ${className}`} data-id="element-142" data-mp="2qmjxdgo2vfi3">
      <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-red-600 hover:bg-red-500 text-white font-black text-sm sm:text-base uppercase tracking-wider rounded-sm whitespace-nowrap transition-colors duration-150 shadow-[0_0_20px_rgba(220,38,38,0.4)]" data-id="element-143" data-mp="2cvok7s6jqc8p">
        Get a Quote
        <ArrowRight className="w-4 h-4 shrink-0" aria-hidden="true" data-id="element-144" data-mp="27x3ljx6y00md" />
      </Link>
      <a href={PHONE_HREF} onClick={trackCallConversion} className="inline-flex items-center justify-center gap-2 px-6 py-4 border-2 border-white/80 text-white hover:bg-white hover:text-black font-black text-sm sm:text-base uppercase tracking-wider rounded-sm whitespace-nowrap transition-colors duration-150" aria-label={`Call or text Mike's Pro Detail at ${PHONE_DISPLAY}`} data-id="element-145" data-mp="1nm92czbl1mds">
        <Phone className="w-4 h-4 shrink-0" aria-hidden="true" data-id="element-146" data-mp="140uxqpocnhbx" />
        Call or Text {PHONE_DISPLAY}
      </a>
    </div>;
}